import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthUseCases } from "@gui/contexts/useCases/UseCasesContext";
import { resetFreshnessFloor } from "@gui/hooks/useFreshOnEntry";

/**
 * Logs the user out and redirects to /login. Single-shot effect on mount —
 * the view is presentational ("Please wait...") while this runs.
 */
export function useLogoutViewModel(): void {
	const navigate = useNavigate();
	const { auth } = useAuthUseCases();

	useEffect(() => {
		auth.logout();
		// This navigates via SPA routing (no hard reload), so the module-level freshness
		// floor would otherwise survive and let the next-logged-in user inherit the
		// previous user's "already fresh" claims.
		resetFreshnessFloor();
		navigate("/login", { replace: true });
	}, []);
}
